"use client";
import { useMaturity } from "#/store/options/page/maturity";
import { parseMaturity } from "#/utils/maturity";

export const OptionChainHeaderGroup: React.FC = () => {
  const { maturity } = useMaturity();

  return (
    <div className="text-textPrimary border-divider font-grotesk relative grid grid-cols-2 place-items-center border-b p-4 font-medium">
      <h6 className="invisible h-4 lg:visible">Calls</h6>
      <h6 className="absolute inset-x-0 mx-auto h-4 w-max text-center uppercase">
        {parseMaturity(maturity)}
      </h6>
      <h6 className="invisible h-4 lg:visible">Puts</h6>
    </div>
  );
};
